<track-table [dataSource]="datatable" [showArtist]="true" [showAlbum]="true" [overrideQueue]="false"></track-table>
